import { jsx as _jsx } from "react/jsx-runtime";
import { ComboboxField, useControllerMerged, } from '@baseplate-dev/ui-components';
import { useMemo, useState } from 'react';
import { FeatureUtils } from '#src/definition/index.js';
import { useProjectDefinition } from '../hooks/use-project-definition.js';
function createCreateOption(value) {
    return {
        label: `Create "${value}"`,
        value,
    };
}
function FeatureComboboxField({ canCreate, value, ...rest }) {
    const { definition } = useProjectDefinition();
    const [searchQuery, setSearchQuery] = useState('');
    const featureOptions = useMemo(() => {
        const baseFeatures = definition.features.map((feature) => ({
            label: feature.name,
            value: feature.id,
        }));
        if (!canCreate)
            return baseFeatures;
        const newFeatureName = searchQuery ? searchQuery : value;
        const doesNewFeatureExist = !!baseFeatures.some((option) => option.label === newFeatureName || option.value === newFeatureName);
        return !doesNewFeatureExist &&
            newFeatureName &&
            FeatureUtils.validateFeatureName(newFeatureName)
            ? [...baseFeatures, createCreateOption(newFeatureName)]
            : baseFeatures;
    }, [definition.features, searchQuery, value, canCreate]);
    return (_jsx(ComboboxField, { placeholder: "Select a feature", ...rest, searchQuery: canCreate ? searchQuery : undefined, onSearchQueryChange: setSearchQuery, options: featureOptions, value: value }));
}
function FeatureComboboxFieldController({ name, control, ...rest }) {
    const { field, fieldState: { error }, } = useControllerMerged({ name, control }, rest);
    const restProps = rest;
    return (_jsx(FeatureComboboxField, { error: error?.message, ...restProps, ...field, value: field.value ?? null }));
}
export { FeatureComboboxField, FeatureComboboxFieldController };
//# sourceMappingURL=feature-combobox-field.js.map